import { render } from "./ViewAcknowledgement.vue?vue&type=template&id=7eec22b5"
import script from "./ViewAcknowledgement.vue?vue&type=script&lang=js"
export * from "./ViewAcknowledgement.vue?vue&type=script&lang=js"

import "./ViewAcknowledgement.vue?vue&type=style&index=0&id=7eec22b5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__